import type { Store, Action, ThunkDispatch } from '@reduxjs/toolkit';
import { NextPageContext } from 'next';
import {
  getClientsideEnvironmentId,
  readEnvironmentIdFromHeaders,
} from '@sbt-web/utils';
import { updateEnvironmentId } from '@/reducers/env';
import type { RootState } from '@/reducers/index';
import { getErrorMessage } from '@/tools/errorHelpers';

export const setEnviromentId = (
  req: NextPageContext['req'] | undefined,
  store: Store<RootState>,
  dispatch: ThunkDispatch<RootState, unknown, Action<string>>
): string | null => {
  let environmentId: string | null = null;

  if (process.env.NEXT_RUNTIME === 'nodejs') {
    try {
      if (req != null) {
        environmentId = readEnvironmentIdFromHeaders(req);
        if (environmentId) {
          store.dispatch(updateEnvironmentId(environmentId));
        }
      }
    } catch (error) {
      console.error(
        'Could not set the Environment ID on the serverside,',
        getErrorMessage(error)
      );
    }
  } else {
    try {
      environmentId = getClientsideEnvironmentId();
      if (environmentId) {
        dispatch(updateEnvironmentId(environmentId));
      }
    } catch (error) {
      console.error(
        'Could not set the Environment ID on the clientside,',
        getErrorMessage(error)
      );
    }
  }

  return environmentId;
};
